// [6.10.2026, 14:27:37] Änderung: Die Zwei-Wochen-Blöcke werden nun kalenderwochenunabhängig über einen festen `periodStart` (Montag der ersten Woche) berechnet, wodurch Lücken beim Jahreswechsel (KW 53/1) vermieden werden. Entsprechend wird das Blockende über `groupEnd` statt über `getLastDayOfWeek`/Kalenderwochen bestimmt und die alte Logik auskommentiert.
// [5.8.2026, 06:41:39] Änderung: Eine neue exportierte Funktion `renderText` wurde hinzugefügt, die Platzhalter in beliebigem Text über `renderTemplate` ersetzt. Sie behandelt leere Templates mit einem leeren String als Fallback.
// [5.8.2026, 06:41:03] Änderung: Es wurde die exportierte Funktion `getInfoText` ergänzt, die Hinweistexte aus `ruleConfig.infoTexts` per Schlüssel lädt und Platzhalter über `renderTemplate` ersetzt. Fehlt der Text, wird ein leerer String gerendert.
// [4.8.2026, 16:24:57] Änderung: Es wurde die exportierte Funktion `getRuleBreak` hinzugefügt, die externen Zugriff auf die per `makeRuleBreak` erzeugten Regelbruch-Daten ermöglicht. Sie akzeptiert Schlüssel, Variablen und optional ein Datum und gibt `RuleBreakData` zurück.
// [4.8.2026, 16:23:22] Änderung: Das Feld `Date` in `RuleBreakData` wurde optional gemacht und erlaubt nun auch `null`. Dadurch müssen Regelverstöße nicht mehr zwingend ein Datum enthalten.
// [4.8.2026, 16:22:36] Änderung: Manuell aufgebaute `ruleBreaks` für zu viele freie Frei-/Sams-/Sonn-/Montage sowie freie Tage in 2 Wochen wurden durch zentrale `makeRuleBreak(...)`-Aufrufe ersetzt. Dabei werden Schwellenwerte nun über `ruleConfig.thresholds` parametrisiert und die Meldungserzeugung vereinheitlicht.
// [4.8.2026, 16:21:06] Änderung: Es wurde eine konfigurierbare `ruleConfig` mit Default-Werten und `loadRuleConfig` eingeführt. Zusätzlich erzeugen neue Helper regelbasierte Meldungen per Template-Rendering aus der Konfiguration.
import { createDefaultRuleConfig } from "@/data/ruleConfig";

export async function loadSettings(shiftSettings: ShiftSettings) {
    if (shiftSettings) {
        let patterns: number[][] = [];
        shiftSettings.schematas.forEach((schemata: any) => {
            const permutations = generatePermutations(schemata.schemata);
            patterns = patterns.concat(permutations);
        });
        
        allowedPatterns = patterns;

        maxFreeDaysInEightWeeks = shiftSettings.shifts.filter((shift: any) => Number(shift.nr) === 10)[0].max;
        
        // Wenn die Freien Tagen nicht limitiert sind, dann wird der maximale Freie Tage werd von den Einstellungen genommen
        if(shiftSettings.limitFreeDaysInTwoWeeks)
        {
            maxFreeDaysInTwoWeeks = maxFreeDaysInEightWeeks / 4;
        }
        else{
            maxFreeDaysInTwoWeeks = shiftSettings.shifts.filter((shift: any) => Number(shift.nr) === 10)[0].max;
        }
        maxFruehdiensteInEightWeeks = shiftSettings.shifts.filter((shift: any) => Number(shift.nr) === 1)[0].max;
        maxSpaetdiensteInEightWeeks = shiftSettings.shifts.filter((shift: any) => Number(shift.nr) === 3)[0].max;
        maxMitteldiensteInEightWeeks = shiftSettings.shifts.filter((shift: any) => Number(shift.nr) === 2)[0].max;

        maxFridaysInEightWeeks = shiftSettings.freeDays.filter((day: any) => day.id === "friday")[0].max;
        maxSaturdaysInEightWeeks = shiftSettings.freeDays.filter((day: any) => day.id === "saturday")[0].max;
        maxSundaysInEightWeeks = shiftSettings.freeDays.filter((day: any) => day.id === "sunday")[0].max;
        maxModaysInEightWeeks = shiftSettings.freeDays.filter((day: any) => day.id === "monday")[0].max;

        maxConsecutiveWorkdays = shiftSettings.misc.filter((misc: any) => misc.id === "maxConsecutiveWorkdays")[0].max;
        
        freeDaysEnabled = shiftSettings.freeDaysEnabled;
        shiftsEnabled = shiftSettings.shiftsEnabled;
        miscEnabled = shiftSettings.miscEnabled;
        schematasEnabled = shiftSettings.schematasEnabled;
    }
}

let allowedPatterns: number[][] = []; 

let maxFreeDaysInEightWeeks = 16;
let maxFreeDaysInTwoWeeks = 4;
let maxFridaysInEightWeeks = 4;
let maxSaturdaysInEightWeeks = 3;
let maxSundaysInEightWeeks = 6;
let maxModaysInEightWeeks = 6;

let maxFruehdiensteInEightWeeks = 30;
let maxSpaetdiensteInEightWeeks = 30;
let maxMitteldiensteInEightWeeks = 30;

let maxConsecutiveWorkdays = 9;

let freeDaysEnabled: boolean = false;
let shiftsEnabled: boolean = false;
let miscEnabled: boolean = false;
let schematasEnabled: boolean = false;

let ruleConfig: RuleConfig = createDefaultRuleConfig();

export function loadRuleConfig(config: RuleConfig) {
    if (config) {
        ruleConfig = config;
    }
}

function renderTemplate(template: string, vars: Record<string, string | number>): string {
    return template.replace(/\{(\w+)\}/g, (_, key) => (vars[key] !== undefined ? String(vars[key]) : `{${key}}`));
}

// Ersetzt Platzhalter ({name}) in einem beliebigen Text
export function renderText(template: string, vars: Record<string, string | number> = {}): string {
    return renderTemplate(template || "", vars);
}

function makeRuleBreak(key: string, vars: Record<string, string | number>, date: Date | null): RuleBreakData {
    const msg = ruleConfig.messages[key] || { message: key, shortMessage: key };
    return {
        ruleMessage: renderTemplate(msg.message, vars),
        ruleShortMessage: renderTemplate(msg.shortMessage, vars),
        Date: date,
    };
}

// Öffentlicher Zugriff auf konfigurierte Regel-Texte für Prüfungen außerhalb der Engine
export function getRuleBreak(key: string, vars: Record<string, string | number> = {}, date: Date | null = null): RuleBreakData {
    return makeRuleBreak(key, vars, date);
}

// Liefert einen konfigurierten Hinweistext mit ersetzten Platzhaltern
export function getInfoText(key: keyof InfoTexts, vars: Record<string, string | number> = {}): string {
    return renderTemplate(ruleConfig.infoTexts[key] || "", vars);
}

// HELPER
const MILLISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000;
const isValidDate = (date:Date | string) => !isNaN(new Date(date).getTime());

const getWeekNumber = (date:Date | string) => {
    const target = new Date(date);
    target.setDate(target.getDate() + 4 - (target.getDay() || 7));
    const yearStart = new Date(target.getFullYear(), 0, 1);
    return Math.ceil((((target.getTime() - yearStart.getTime()) / 1000) / 60 / 60 / 24 + 1) / 7);
};
function getLastDayOfWeek(weekNumber: number, year: number): Date {
    // Ersten Tag des Jahres
    const firstDayOfYear = new Date(year, 0, 1);
    
    // Berechne den ersten Montag des Jahres
    const firstMonday = new Date(firstDayOfYear);
    const dayOfWeek = firstDayOfYear.getDay();
    const daysToAdd = dayOfWeek === 0 ? 1 : 8 - dayOfWeek;
    firstMonday.setDate(firstDayOfYear.getDate() + daysToAdd);
    
    // Berechne den letzten Tag (Sonntag) der gewünschten Woche
    const lastDay = new Date(firstMonday);
    lastDay.setDate(firstMonday.getDate() + (weekNumber - 1) * 7 + 6);
    
    return lastDay;
}
const isWithinNDays = (date1:Date | string, date2:Date | string, n:number) => {
    const d1 = new Date(date1).getTime();
    const d2 = new Date(date2).getTime();
    return Math.abs(d1 - d2) <= n * MILLISECONDS_IN_A_DAY;
};
const getDayOfWeek = (date: Date | string) => new Date(date).getDay();

const getDaysBetweenDates = (date1:Date | string, date2:Date | string) => {
    // Erstelle Datumsobjekte und setze die Zeit auf Mitternacht (00:00:00.000)
    const d1 = new Date(date1);
    d1.setHours(0, 0, 0, 0);
    
    const d2 = new Date(date2);
    d2.setHours(0, 0, 0, 0);

    const differenceInMilliseconds = Math.abs(d2.getTime() - d1.getTime());
    const days = Math.round(differenceInMilliseconds / MILLISECONDS_IN_A_DAY);
//    console.log("Days between", date1, "and", date2, "is", days);
    return days;
}
const isSunday = (date:Date | string) => getDayOfWeek(date) === 0;
const isMonday = (date:Date | string) => getDayOfWeek(date) === 1;
const isFriday = (date:Date | string) => getDayOfWeek(date) === 5;
const isSaturday = (date:Date | string) => getDayOfWeek(date) === 6;

const getTwoWeekGroupsAsArrays = (startDate) => {
    const groups = [];
    let currentDate = new Date(startDate);

    // Helper function to get the week number of the year
    /*function getWeekNumber(date) {
        const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
        const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
        return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
    }*/

    while (currentDate.getFullYear() === new Date(startDate).getFullYear()) {
        const week1 = getWeekNumber(currentDate); // Current week number
        currentDate.setDate(currentDate.getDate() + 7); // Move to next week
        const week2 = getWeekNumber(currentDate); // Next week's number

        // Create the group as an array [week1, week2]
        const group = [week1, week2];
        groups.push(group); // Add group to the list

        currentDate.setDate(currentDate.getDate() + 7); // Move to the week after
    }

    return groups;
}

const findGroupForWeek = (groups, week) => {
    for (const group of groups) {
        if (group.includes(week)) {
            return group; 
        }
    }
    return null; 
}

const isValidFreePattern = (pattern:number[]) => {
//    console.log("Checking pattern:", pattern, "against allowed patterns:", allowedPatterns);
    return allowedPatterns.some((allowedPattern) =>
        JSON.stringify(allowedPattern) === JSON.stringify(pattern)
    );
};

function extractFirstAndLastDates(dates:NEWDay[]) {
    // Convert date strings to Date objects and group by year
    const groupedByYear = dates.reduce((acc, dateObj) => {
        const date = new Date(dateObj.Date); // Assuming dateObj has a "date" key
        const year = date.getFullYear();

        if (!acc[year]) acc[year] = [];
        acc[year].push(date);

        return acc;
    }, {});

    // Extract first and last date of each year
    const result = Object.entries(groupedByYear).map(([year, dates]) => {
        dates.sort((a, b) => a - b); // Sort dates within the year
        return {
            year: parseInt(year),
            first: dates[0],
            last: dates[dates.length - 1]
        };
    });

    return result;
}

function arraysEqual(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false; // Check if lengths are different
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false; // Compare elements at each index
    }
    return true; // Arrays are equal
}

function generatePermutations(array: number[]): number[][] {
    if (array.length === 0) return [[]]; // Base case: empty array
    if (array.length === 1) return [array]; // Base case: single-element array

    const result: number[][] = [];
    for (let i = 0; i < array.length; i++) {
        const current = array[i];
        const remaining = array.slice(0, i).concat(array.slice(i + 1));
        const perms = generatePermutations(remaining);

        for (const perm of perms) {
            result.push([current, ...perm]);
        }
    }
    return result;
}


function getWeekStart(date:Date) {
    const d = new Date(date);
    const day = d.getDay();
    const diff = day === 0 ? -6 : 1 - day; // Adjust for Sunday being day 0
    d.setDate(d.getDate() + diff);
    d.setHours(0, 0, 0, 0); // Reset time to midnight
    return d;
}

export function calculateReducedFreeDays(vacationArray: EmployVacationData[], cycleId: string) {

    if (cycleId.toLowerCase() === "od01" || cycleId.toLowerCase() === "260a" ||
        cycleId.toLowerCase() === "260b" || cycleId.toLowerCase() === "260c") {
        cycleId = "170"
    }
    // Convert vacationArray to Date objects
    const vacations = vacationArray.map(d => new Date(d.date)).sort((a, b) => a - b);

    // Group vacation days by week
    const vacationWeeks: { [key: string]: Set<string> } = {};
    vacations.forEach(date => {
        const weekStart = getWeekStart(date).toISOString(); // ISO string as key
        if (!vacationWeeks[weekStart]) vacationWeeks[weekStart] = new Set();
        vacationWeeks[weekStart].add(date.toISOString());
    });

    // Calculate deductions
    let totalDeductedDays = 0;
    let nextDeduction = 0;
    
    if(cycleId === '170')
        nextDeduction = 2;
    else if(cycleId === '170t')
        nextDeduction = 4;
    else if(cycleId === '170u' || cycleId === '170v')
        nextDeduction = 3;
    
    Object.values(vacationWeeks).forEach((days: Set<string>) => {
        const dayCount = days.size; // Unique days in this week
        // Prüfe ob Samstag und Sonntag in der Woche vorhanden sind
        let hasSaturday = false
        let hasSunday = false
        
        days.forEach(dateIso => {
            const date = new Date(dateIso);
            const dayOfWeek = date.getDay();
            if (dayOfWeek === 6) hasSaturday = true; // Samstag
            if (dayOfWeek === 0) hasSunday = true;   // Sonntag
        })

        if (dayCount >= 6 || (hasSaturday && hasSunday && dayCount < 6)) {
            totalDeductedDays += nextDeduction; // Deduct 2 days for each full week
        } else if ((hasSaturday || hasSunday) && dayCount <= 2) {
            totalDeductedDays += 1; // Deduct 1 day if only one weekend day is taken
        }
// Es werden nur volle Urlaubswochen berücksichtigt !!!        
/*        else if (cycleId === '170' && dayCount >= 1) {
            totalDeductedDays += 1;
        }*/
        
        if(cycleId === '170v' && nextDeduction === 3)
            nextDeduction = 4;
        else if(cycleId === '170v' && nextDeduction === 4)
            nextDeduction = 3;
    });
    console.log("Total Deducted Days for cycle", cycleId, "is", totalDeductedDays);
    return totalDeductedDays;
}

export interface RuleBreakData {
    ruleMessage: string;
    ruleShortMessage: string;
    Date?: Date | null;
}
export function checkRuleBreaksForShifts(entries:WishDataDate[], vacationFreeDays:number = 0, 
    first14Days: WishDataDate[] = []): {ruleBreaks: RuleBreakData[]} {
    
    // Filter out entries with invalid or empty dates
    const validEntries = entries.filter(entry => isValidDate(entry.date));

    // Sort the valid entries by date
    validEntries.sort((a, b) => a.date.getTime() - b.date.getTime());

    let freeCount:number=0;
    let freeCountInTwoWeeks:number = 0;
    let freeDayGroups:number[] = []; 
    let saturdayCount:number = 0;
    let saturdayHolidayCount:number = 0;
    let sundayCount:number = 0;
    let fridayCount:number = 0;
    let mondayCount:number = 0;
    let ruleBreaks:RuleBreakData[] = [];
    let consecutiveWorkdays:number = 0;
    let firstWorkdays: number = 0;

    // ALT: let totalFreeDayGroups  = [];
    // Zwei-Wochen-Blöcke ab Montag der ersten Woche, damit der Jahreswechsel (KW 53/1) keine Lücken erzeugt
    const periodStart = validEntries.length > 0 ? getWeekStart(validEntries[0].date) : new Date();
    
    let fruehdiensteCount = 0;
    let mitteldiensteCount = 0;
    let spaetdiensteCount = 0;
    
    let lastFreeWeekNumbers:number[] = [];
    // ALT: let currentWeekNumber:number = 0;
    
    for (let i = 0; i < first14Days.length; i++) {
        //console.log("First 14 Days Entry:", first14Days[i].shift, first14Days[i].date.toLocaleDateString("de-DE"));
        switch(first14Days[i].shift) {
            case 1:
            case 2:
            case 3:
            case 4:
                firstWorkdays++
                break;
            default:
                firstWorkdays = 0
                break;
        }
    }
    //console.log("First 14 Days Workdays:", firstWorkdays, validEntries);
    consecutiveWorkdays = firstWorkdays;

    for (let i = 0; i < validEntries.length; i++) {
        const currentEntry = validEntries[i];
        const previousEntry = validEntries[i - 1] || null;
        const currentId = currentEntry.shift;
        const currentDate = currentEntry.date;
        //console.log("CurrentId:", currentId, "Date:", currentDate.toLocaleDateString("de-DE"));
        let daysBetweenDates = 0;
        
        if(previousEntry)
        {
            daysBetweenDates = getDaysBetweenDates(currentDate, previousEntry.date);
        }
        // ALT:
        // else{
        //     totalFreeDayGroups = getTwoWeekGroupsAsArrays(currentDate);
        // }
        // currentWeekNumber = getWeekNumber(currentEntry.date);
        // const weekGroup = findGroupForWeek(totalFreeDayGroups, currentWeekNumber);
        const groupIndex = Math.floor(getDaysBetweenDates(periodStart, currentDate) / 14);
        const weekGroup = [groupIndex];
        const groupEnd = new Date(periodStart);
        groupEnd.setDate(periodStart.getDate() + groupIndex * 14 + 13);
        
        if(currentEntry.shift === 1) fruehdiensteCount++;
        if(currentEntry.shift === 2) mitteldiensteCount++;
        if(currentEntry.shift === 3) spaetdiensteCount++;
        
        if(shiftsEnabled)
        {
            if(fruehdiensteCount > maxFruehdiensteInEightWeeks)
            {
                ruleBreaks.push(makeRuleBreak("tooManyFruehdienste", {max: maxFruehdiensteInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
            }

            if(mitteldiensteCount > maxMitteldiensteInEightWeeks)
            {
                ruleBreaks.push(makeRuleBreak("tooManyMitteldienste", {max: maxMitteldiensteInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
            }

            if(spaetdiensteCount > maxSpaetdiensteInEightWeeks)
            {
                ruleBreaks.push(makeRuleBreak("tooManySpaetdienste", {max: maxSpaetdiensteInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
            }
        }

        
        // Track the number of Free days in 2 weeks (only for 'Free' days)
        if (currentId === 10) {

            freeCount++;
            
            if (isFriday(currentDate)) fridayCount++;
            if (isSaturday(currentDate)) saturdayCount++;
            if (isSunday(currentDate)) sundayCount++;
            if (isMonday(currentDate)) mondayCount++;
            
            if(freeDaysEnabled)
            {
                if (fridayCount > maxFridaysInEightWeeks) {
                    ruleBreaks.push(makeRuleBreak("tooManyFridays", {max: maxFridaysInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
                }
                if (saturdayCount > maxSaturdaysInEightWeeks) {
                    ruleBreaks.push(makeRuleBreak("tooManySaturdays", {max: maxSaturdaysInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
                }
                if (sundayCount > maxSundaysInEightWeeks) {
                    ruleBreaks.push(makeRuleBreak("tooManySundays", {max: maxSundaysInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
                }
                if (mondayCount > maxModaysInEightWeeks) {
                    ruleBreaks.push(makeRuleBreak("tooManyMondays", {max: maxModaysInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
                }
            }
            

            consecutiveWorkdays = 0;
            firstWorkdays = 0;
//            currentWeekNumber = getWeekNumber(currentEntry.date);
//            console.log("Total Week Groups:", totalFreeDayGroups);
//            const weekGroup = findGroupForWeek(totalFreeDayGroups, currentWeekNumber);
//            console.log("Current Week Number:", currentWeekNumber, "Week Group:", weekGroup,
//                "Last Free Week Numbers:", lastFreeWeekNumbers);
            
            if(lastFreeWeekNumbers?.length === null || lastFreeWeekNumbers?.length === 0)
            {
                lastFreeWeekNumbers = weekGroup;
                freeDayGroups = [];
                freeCountInTwoWeeks = 0;
            }
            else{
                if(!arraysEqual(lastFreeWeekNumbers,weekGroup))
                {
                    freeCountInTwoWeeks = 0;
                    lastFreeWeekNumbers = weekGroup;
                    freeDayGroups = [];
                }
            }
            // Check if the current Free day is consecutive to the previous day
            /*console.log("10 Previous Entry:", previousEntry ? previousEntry.shift : "None", 
                "Days Between:", daysBetweenDates, "Free Day Groups:", freeDayGroups);*/
            if (previousEntry && (previousEntry.shift === 10 || previousEntry.shift === 12) && freeDayGroups.length > 0 && daysBetweenDates === 1) {
                // If it's a consecutive Free day, we add to the group (no reset)
                freeDayGroups[freeDayGroups.length - 1]++;
            } else {
                // If it's a standalone Free day, start a new group
                freeDayGroups.push(1);
            }

            freeCountInTwoWeeks = freeDayGroups.reduce((a, b) => a + b, 0);
            
            // Check if 2-week Free day limit is exceeded
//            console.log("FreeCountInTwoWeeks:", freeCountInTwoWeeks, "MaxFreeDaysInTwoWeeks:", maxFreeDaysInTwoWeeks);
            if (freeCountInTwoWeeks > maxFreeDaysInTwoWeeks) {
                ruleBreaks.push(makeRuleBreak("tooManyFreeDaysTwoWeeks", {freeWeeks: ruleConfig.thresholds.freeDaysWeekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
            }
        } else if (currentId === 11) {
            consecutiveWorkdays = 0;
            firstWorkdays = 0;
             // Reset the Free day counter if a non-Free day is encountered
             freeCountInTwoWeeks = 0;
        } else if (currentId === 12) {
            if (isFriday(currentDate)) fridayCount++;
            if (isSaturday(currentDate)) {
                if (saturdayHolidayCount < 1) {
                    saturdayCount++;
                }
                saturdayHolidayCount++;
            }
            if (isSunday(currentDate)) sundayCount++;
            if (isMonday(currentDate)) mondayCount++;
            
            if(freeDaysEnabled)
            {
                if (fridayCount > maxFridaysInEightWeeks) {
                    ruleBreaks.push(makeRuleBreak("tooManyFridays", {max: maxFridaysInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
                }
                if (saturdayCount > maxSaturdaysInEightWeeks) {
                    ruleBreaks.push(makeRuleBreak("tooManySaturdays", {max: maxSaturdaysInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
                }
                if (sundayCount > maxSundaysInEightWeeks) {
                    ruleBreaks.push(makeRuleBreak("tooManySundays", {max: maxSundaysInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
                }
                if (mondayCount > maxModaysInEightWeeks) {
                    ruleBreaks.push(makeRuleBreak("tooManyMondays", {max: maxModaysInEightWeeks, weeks: ruleConfig.thresholds.weekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
                }
            }
            consecutiveWorkdays = 0;
            firstWorkdays = 0;
//            currentWeekNumber = getWeekNumber(currentEntry.date);
//            const weekGroup = findGroupForWeek(totalFreeDayGroups, currentWeekNumber);
            
            if(lastFreeWeekNumbers?.length === null || lastFreeWeekNumbers?.length === 0)
            {
                lastFreeWeekNumbers = weekGroup;
                freeDayGroups = [];
                freeCountInTwoWeeks = 0;
            }
            else{
                if(!arraysEqual(lastFreeWeekNumbers,weekGroup))
                {
                    freeCountInTwoWeeks = 0;
                    lastFreeWeekNumbers = weekGroup;
                    freeDayGroups = [];
                }
            }
            // Check if the current Free day is consecutive to the previous day
            /*console.log("12 Previous Entry:", previousEntry ? previousEntry.shift : "None", 
                "Days Between:", daysBetweenDates, "Free Day Groups:", freeDayGroups);*/
            if (previousEntry && (previousEntry.shift === 10 || previousEntry.shift === 12) && freeDayGroups.length > 0 && daysBetweenDates === 1) {
                // If it's a consecutive Free day, we add to the group (no reset)
                freeDayGroups[freeDayGroups.length - 1]++;
            } else {
                // If it's a standalone Free day, start a new group
                freeDayGroups.push(1);
            }

            freeCountInTwoWeeks = freeDayGroups.reduce((a, b) => a + b, 0);
            
            // Check if 2-week Free day limit is exceeded
//            console.log("FreeCountInTwoWeeks:", freeCountInTwoWeeks, "MaxFreeDaysInTwoWeeks:", maxFreeDaysInTwoWeeks);
            if (freeCountInTwoWeeks > maxFreeDaysInTwoWeeks) {
                ruleBreaks.push(makeRuleBreak("tooManyFreeDaysTwoWeeks", {freeWeeks: ruleConfig.thresholds.freeDaysWeekWindow, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
            }
        } else {
            // Reset the Free day counter if a non-Free day is encountered
            freeCountInTwoWeeks = 0;
            saturdayHolidayCount = 0;
            // Count consecutive workdays (since Free days reset it)
            consecutiveWorkdays++;
            
            if(miscEnabled)
            {
                if (consecutiveWorkdays > maxConsecutiveWorkdays) {
                    ruleBreaks.push(makeRuleBreak("tooManyConsecutiveWorkdays", {max: maxConsecutiveWorkdays, date: currentDate.toLocaleDateString("de-DE")}, currentDate));
                }
            }
            
            // Early can't follow Late or NE
            if ((currentId === 1) && previousEntry && (previousEntry.shift === 3 || previousEntry.shift === 4) && daysBetweenDates === 1) {
                ruleBreaks.push(makeRuleBreak("earlyAfterLate", {date: currentDate.toLocaleDateString("de-DE")}, currentDate));
            }
        }

        // Only allow another NE or Late after NE
        if (previousEntry && previousEntry.shift === 4 && currentId !== 4 && currentId !== 3 && daysBetweenDates === 1) {
            ruleBreaks.push(makeRuleBreak("afterNE", {date: currentDate.toLocaleDateString("de-DE")}, currentDate));
        }
        
        if(schematasEnabled)
        {
            // Check for valid Free day sequence pattern every two weeks (only for 'Free' days)
            // ALT: const _lastDate = getLastDayOfWeek(weekGroup[0], currentDate.getFullYear())
            const _isValidFreePattern = isValidFreePattern(freeDayGroups);
            /*console.log("Free Day Groups:", freeDayGroups, "Is Valid Pattern:", _isValidFreePattern,
                "Current Date:", currentDate.toLocaleDateString("de-DE"), 
                "Last Day of Week Group:", _lastDate.toLocaleDateString("de-DE"),
                "weekGroup:", weekGroup, "Total Free Day Groups:", totalFreeDayGroups
            );*/
            //if (!_isValidFreePattern && freeCountInTwoWeeks >= maxFreeDaysInTwoWeeks) {
            // ALT: if (!_isValidFreePattern && currentDate.toDateString() === _lastDate.toDateString()) {
            if (!_isValidFreePattern && currentDate.toDateString() === groupEnd.toDateString()) {
                ruleBreaks.push(makeRuleBreak("invalidFreePattern", {pattern: JSON.stringify(freeDayGroups), date: currentDate.toLocaleDateString("de-DE")}, currentDate));
            }
        }
    }
    
    if(shiftsEnabled)
    {
        if(freeCount < ((maxFreeDaysInEightWeeks) - vacationFreeDays) && freeCount > 0) {
            ruleBreaks.push(makeRuleBreak("tooFewFreeDays", {weeks: ruleConfig.thresholds.weekWindow}, null));
        }

        if(freeCount > ((maxFreeDaysInEightWeeks) - vacationFreeDays)) {
            ruleBreaks.push(makeRuleBreak("tooManyFreeDays", {weeks: ruleConfig.thresholds.weekWindow}, null));
        }
    }
    
    return ruleBreaks;
}

export function checkRuleBreaksForVacation(VacationPriority:VacationPrio, summervacation:NEWDay[], maxDays:number) {
    let ruleBreaks:RuleBreakData[] = [];
    
    if(VacationPriority.startDate && VacationPriority.endDate)
    {
        // Normal Urlaub
        if(!isMonday(VacationPriority.startDate))
        {
            ruleBreaks.push(makeRuleBreak("vacationMustStartMonday", {date: VacationPriority.startDate.toLocaleDateString("de-DE")}, VacationPriority.startDate));
        }

        if(!isSunday(VacationPriority.endDate))
        {
            ruleBreaks.push(makeRuleBreak("vacationMustEndSunday", {date: VacationPriority.endDate.toLocaleDateString("de-DE")}, VacationPriority.endDate));
        }
        if(getDaysBetweenDates(VacationPriority.startDate, VacationPriority.endDate) < (ruleConfig.thresholds.vacationMinDays - 1)) {
            ruleBreaks.push(makeRuleBreak("vacationMinDays", {minDays: ruleConfig.thresholds.vacationMinDays}, VacationPriority.startDate));
        }
        
        if(getDaysBetweenDates(VacationPriority.startDate, VacationPriority.endDate) >= ruleConfig.thresholds.vacationMaxDays)
        {
            ruleBreaks.push(makeRuleBreak("vacationMaxDays", {maxDays: ruleConfig.thresholds.vacationMaxDays}, VacationPriority.endDate));
            
        }
        
        
        
        // Urlaub in den Sommerferien
/*        
        extractFirstAndLastDates(summervacation).forEach((year) => {
            if ((VacationPriority.startDate < year.first && VacationPriority.endDate < year.first) || (VacationPriority.startDate > year.last && VacationPriority.endDate > year.last)) {
                return;
            }
            
            const threeWeeksEnd = new Date(year.first);
            threeWeeksEnd.setDate(threeWeeksEnd.getDate() + 20);
            
            // Validate the user's vacation dates
            const isWithinFirstThreeWeeks = VacationPriority.startDate.setHours(0, 0, 0, 0) >= year.first.setHours(0, 0, 0, 0) && VacationPriority.endDate.setHours(0, 0, 0, 0) <= threeWeeksEnd.setHours(0, 0, 0, 0);
            const isWithinRestOfSummer = VacationPriority.startDate.setHours(0, 0, 0, 0) >= threeWeeksEnd.setHours(0, 0, 0, 0) && VacationPriority.endDate.setHours(0, 0, 0, 0) <= year.last.setHours(0, 0, 0, 0);
            
            if(!isWithinFirstThreeWeeks && !isWithinRestOfSummer)
            {
                ruleBreaks.push({ruleMessage: `Sommerurlaub Fehlerhaft`,
                    ruleShortMessage: `Sommerurlaub Fehler`,
                    Date: VacationPriority.startDate});
            }
        });*/
    }
    
    return ruleBreaks;
    
}
    